import React, { useEffect, useState } from "react";
import { Col, Container, Form, Row, Modal } from "react-bootstrap";
import { CstmPagination } from "../../../../components/Common/Common";
import { Link, useParams } from "react-router-dom";

// img
import d1 from "../../../../Assets/images/doc.png";
import u1 from "../../../../Assets/images/user.png";
import noImage from "../../../../Assets/images/no-img.png"
import CustomerCounter from "../../CustomerDetail/Component/CustomerCounter";
import { useDispatch, useSelector } from "react-redux";
import { getDriverView } from "../../../../store/drivers/actions";
import Table from "../../../../components/Common/Table";
import moment from "moment";
import Slider from "react-slick";

const DriverDetail = () => {
  var settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  const { id } = useParams();
  const dispatch = useDispatch();
  const driverDataView = useSelector((s) => s.driver.driverDataView);

  const [showModal, setShowModal] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);

  const handleImageClick = (image) => {
    setSelectedImage(image);
    setShowModal(true);
  };

  const handleClose = () => {
    setShowModal(false);
    setSelectedImage(null);
  };

  useEffect(() => {
    if (id) dispatch(getDriverView(id));
  }, [id]);

  const column = [
    {
      label: "Booking Id",
      id: "bookingNumber",
    },
    {
      label: "Customer Name",
      id: "customerName",
      classNames: "themeBlue m-0 fw-sbold",
    },
    {
      label: "Total Amount",
      id: "totalAmount",
      isComponent: true,
      component: (item, key) => <p className="m-0">${item?.totalAmount}</p>,
    },
    { label: "Payment Method", id: "paymentMethod" },
    {
      label: "Driver or Agency Earning",
      id: "driverOrAgencyEarning",
      isComponent: true,
      component: (item, key) => (
        <p className="m-0">${item?.driverOrAgencyEarning}</p>
      ),
    },
    {
      label: "Admin Earning",
      id: "adminEarning",
      isComponent: true,
      component: (item, key) => <p className="m-0">${item?.adminEarning}</p>,
    },
    {
      label: "Status",
      id: "",
      isComponent: true,
      component: (item, key) => (
        <p
          className={`${item.status === "completed" ? "text-success" : "text-primary"
            } m-0 fw-sbold`}
        >
          {item.status.charAt(0).toUpperCase() + item.status.slice(1)}
        </p>
      ),
    },
    {
      label: "Created at",
      id: "createdAt",
      isComponent: true,
      component: (item) => (
        <p className={` m-0`}>
          {moment(item.createdAt).format("MM-DD-YYYY , HH:mm A")}
        </p>
      ),
    },
    {
      label: "Actions",
      id: "",
      isComponent: true,
      component: (item) => (
        <div className="ActnBtn">
          <Link
            to={`/manage-booking/detail/${item.bookingId}`}
            // to={`/manage-driver/booking-detail/${item.bookingId}`}
            className="border-0 p-0"
            variant="transparent"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="18"
              height="18"
              viewBox="0 0 25 17"
              fill="none"
            >
              <path
                d="M24.8389 7.9541C22.8564 5.34668 20.8301 3.35937 18.8184 2.04102C16.7578 0.693359 14.6582 0.00488281 12.5684 0C12.5586 0 12.5488 0 12.5391 0C10.4443 0 8.3252 0.683594 6.25 2.03613C4.22363 3.34961 2.17285 5.3418 0.161133 7.94922C-0.0537109 8.23242 -0.0537109 8.62305 0.161133 8.90137C2.17285 11.5137 4.22363 13.5059 6.25 14.8193C8.33008 16.1719 10.4443 16.8555 12.5391 16.8555H12.5684C14.6582 16.8506 16.7627 16.1621 18.8184 14.8145C20.8301 13.4961 22.8516 11.5088 24.8389 8.90137C25.0537 8.62305 25.0537 8.23242 24.8389 7.9541ZM12.5635 15.293C12.5537 15.293 12.5439 15.293 12.5391 15.293C9.02832 15.293 5.40527 12.9834 1.77246 8.42773C5.40527 3.87207 9.02344 1.5625 12.5391 1.5625H12.5635C16.0645 1.57227 19.6533 3.88184 23.2275 8.42773C19.6533 12.9736 16.0693 15.2832 12.5635 15.293ZM12.5 3.54492C9.80957 3.54492 7.61719 5.73731 7.61719 8.42773C7.61719 11.1182 9.80957 13.3105 12.5 13.3105C15.1904 13.3105 17.3828 11.1182 17.3828 8.42773C17.3828 5.73731 15.1904 3.54492 12.5 3.54492ZM12.5 11.748C10.6689 11.748 9.17969 10.2588 9.17969 8.42773C9.17969 6.59668 10.6689 5.10742 12.5 5.10742C14.3311 5.10742 15.8203 6.59668 15.8203 8.42773C15.8203 10.2588 14.3311 11.748 12.5 11.748Z"
                fill="#666666"
              />
            </svg>
          </Link>
        </div>
      ),
    },
  ];

  return (
    <>
      <section className="AgencyDetail py-3 position-relative">
        <Container>
          <Row className="justify-content-between">
            <Col lg="12" className="my-2">
              <Link to="/manage-driver/registered-driver" className="">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="41"
                  height="41"
                  viewBox="0 0 41 41"
                  fill="none"
                >
                  <rect
                    x="0.5"
                    y="0.5"
                    width="40"
                    height="40"
                    rx="11.5"
                    fill="white"
                    stroke="#D9DADC"
                  />
                  <path
                    d="M23.1573 13.3669C23.0654 13.2747 22.9562 13.2016 22.836 13.1517C22.7157 13.1019 22.5869 13.0762 22.4567 13.0762C22.3265 13.0762 22.1976 13.1019 22.0774 13.1517C21.9572 13.2016 21.848 13.2747 21.7561 13.3669L15.1773 19.9456C15.1039 20.0189 15.0457 20.1059 15.006 20.2017C14.9662 20.2974 14.9458 20.4001 14.9458 20.5038C14.9458 20.6075 14.9662 20.7101 15.006 20.8059C15.0457 20.9017 15.1039 20.9887 15.1773 21.0619L21.7561 27.6406C22.144 28.0286 22.7694 28.0286 23.1573 27.6406C23.5452 27.2527 23.5452 26.6273 23.1573 26.2394L17.4257 20.4998L23.1652 14.7602C23.5452 14.3802 23.5452 13.7469 23.1573 13.3669Z"
                    fill="#1E232C"
                    stroke="#1E232C"
                    stroke-width="0.2"
                  />
                </svg>
              </Link>
            </Col>
            <Col lg="12" className="my-2">
              <CustomerCounter isCustomer={false} driverData={driverDataView} />
            </Col>
            <Col md="6" className="my-2">
              <h5 className="m-0 pb-2 fw-sbold themeBlue mt-4">
                Driver Details:
              </h5>
              <div className="cardCstm border rounded px-3 py-2">
                <ul className="list-unstyled ps-0 mb-0 noLastBorder">
                  <li className="py-2 d-flex align-items-center justify-content-between gap-10">
                    <span className="w-50 text-muted fw-sbold">
                      Driver Name:
                    </span>
                    <p className="m-0 text-danger w-50 fw-sbold">
                      {driverDataView?.driverDetails?.name}
                    </p>
                  </li>
                  <li className="py-2 d-flex align-items-center justify-content-between gap-10">
                    <span className="w-50 text-muted fw-sbold">
                      Phone Number:
                    </span>
                    <p className="m-0 text-danger w-50 fw-sbold">
                      {driverDataView?.driverDetails?.mobileNumber}
                    </p>
                  </li>
                  <li className="py-2 d-flex align-items-center justify-content-between gap-10">
                    <span className="w-50 text-muted fw-sbold">Email ID:</span>
                    <p className="m-0 text-danger w-50 fw-sbold">
                      {driverDataView?.driverDetails?.email}
                    </p>
                  </li>
                </ul>
              </div>
            </Col>
            <Col md="6" className="my-2">
              <h5 className="m-0 pb-2 fw-sbold themeBlue mt-4">
                Bank Account Details:
              </h5>
              <div className="cardCstm border rounded px-3 py-2">
                <ul className="list-unstyled ps-0 mb-0 noLastBorder">
                  <li className="py-2 d-flex align-items-center justify-content-between gap-10">
                    <span className="w-50 text-muted fw-sbold">Bank Name:</span>
                    <p className="m-0 text-danger w-50 fw-sbold">
                      {
                        driverDataView?.driverDetails?.accountDetails?.[0]
                          ?.bankName
                      }
                    </p>
                  </li>
                  <li className="py-2 d-flex align-items-center justify-content-between gap-10">
                    <span className="w-50 text-muted fw-sbold">
                      Routing number:
                    </span>
                    <p className="m-0 text-danger w-50 fw-sbold">
                      {
                        driverDataView?.driverDetails?.accountDetails?.[0]
                          ?.routingNumber
                      }
                    </p>
                  </li>
                  <li className="py-2 d-flex align-items-center justify-content-between gap-10">
                    <span className="w-50 text-muted fw-sbold">
                      Account number:
                    </span>
                    <p className="m-0 text-danger w-50 fw-sbold">
                      {
                        driverDataView?.driverDetails?.accountDetails?.[0]
                          ?.accountNumber
                      }
                    </p>
                  </li>
                </ul>
              </div>
            </Col>

            <Col lg="6" className="my-2">
              <h5 className="m-0 pb-2 fw-sbold themeBlue">Vehicle Details</h5>{" "}
              <Slider {...settings}>
                {driverDataView?.vehicleDetailsList?.map((item) => {
                  return (
                    <div
                      className="cardCstm border rounded px-3 py-2"
                      style={{
                        height: "12rem",
                      }}
                    >
                      <ul className="list-unstyled ps-0 mb-0 noLastBorder">
                        <li className="py-2 d-flex align-items-center justify-content-between gap-10">
                          <span className="w-50 text-muted fw-sbold">
                            Vehicle Image:
                          </span>
                          <p className="m-0 text-danger w-50 fw-sbold">
                            {item?.serviceDetails?.image ?
                              <img src={item?.serviceDetails?.image} style={{ height: "40px" }} /> :
                              <img src={noImage} style={{ height: "40px" }} />}
                          </p>
                        </li>
                        <li className="py-2 d-flex align-items-center justify-content-between gap-10">
                          <span className="w-50 text-muted fw-sbold">
                            Vehicle Name:
                          </span>
                          <p className="m-0 text-danger w-50 fw-sbold">
                            {item?.serviceDetails?.name || "N/A"}
                          </p>
                        </li>
                        <li className="py-2 d-flex align-items-center justify-content-between gap-10">
                          <span className="w-50 text-muted fw-sbold">
                            Vehicle Type:
                          </span>
                          <p className="m-0 text-danger w-50 fw-sbold">
                            {item?.serviceDetails?.type || "N/A"}
                          </p>
                        </li>
                        <li className="py-2 d-flex align-items-center justify-content-between gap-10">
                          <span className="w-50 text-muted fw-sbold">
                            Vehicle License Plate:
                          </span>
                          <p className="m-0 text-danger w-50 fw-sbold">
                            {item?.plateNumber || "N/A"}
                          </p>
                        </li>
                        <li className="py-2 d-flex align-items-center justify-content-between gap-10">
                          <span className="w-50 text-muted fw-sbold">
                            Vehicle Model:
                          </span>
                          <p className="m-0 text-danger w-50 fw-sbold">
                            {item?.model || "N/A"}
                          </p>
                        </li>
                        <li className="py-2 d-flex align-items-center justify-content-between gap-10">
                          <span className="w-50 text-muted fw-sbold">
                            Vehicle Make:
                          </span>
                          <p className="m-0 text-danger w-50 fw-sbold">
                            {" "}
                            {item?.make || "N/A"}
                          </p>
                        </li>
                        <li className="py-2 d-flex align-items-center justify-content-between gap-10">
                          <span className="w-50 text-muted fw-sbold">
                            Vehicle Color:
                          </span>
                          <p className="m-0 text-danger w-50 fw-sbold">
                            {item?.color || "N/A"}
                          </p>
                        </li>
                        <li className="py-2 d-flex align-items-center justify-content-between gap-10">
                          <span className="w-50 text-muted fw-sbold">
                            Weight Capacity(lb):
                          </span>
                          <p className="m-0 text-danger w-50 fw-sbold">
                            {item?.serviceDetails?.weightCapacity || 0}
                          </p>
                        </li>
                      </ul>
                    </div>
                  );
                })}
              </Slider>
            </Col>


            <Col
              md="6"
              className="my-2"
            // style={{
            //   height:"12rem"
            // }}
            >
              <h5 className="m-0 pb-2 fw-sbold themeBlue">Document</h5>
              <Slider {...settings}>
                {driverDataView?.driverDetails?.documentsList?.map(
                  (item, index) => {
                    const { image } = item;

                    return (
                      <div>
                        <div
                          key={index}
                          className="cardCstm border text-center rounded px-3 py-2 d-flex justify-content-center align-items-center"
                          style={{ border: "black", height: "auto" }}
                        >
                          {/* <img
                            src={image || d1}
                            alt=""
                            // className="img-fluid mx-auto"
                            style={{
                              width: 100,
                              height: 100,
                            }}
                          /> */}
                          <img
                            src={image || d1}
                            alt="document"
                            // className="img-fluid object-fit-contain"
                            style={{
                              height: 300,
                              width: 300,
                              cursor: "pointer",
                              margin: "28px",
                              borderRadius: "0.5rem"
                            }}
                            onClick={() => handleImageClick(image || d1)}
                          />
                        </div>
                      </div>
                    );
                  }
                )}
              </Slider>
            </Col>
            <Modal show={showModal} onHide={handleClose} centered>
              <Modal.Header closeButton>
                {/* <Modal.Title>Document Preview</Modal.Title> */}
              </Modal.Header>
              <Modal.Body className="text-center">
                {selectedImage && (
                  <img
                    src={selectedImage}
                    alt="Document Preview"
                    className="img-fluid"
                    style={{ maxHeight: "500px" }}
                  />
                )}
              </Modal.Body>
            </Modal>
            <Col lg="12" className="my-2">
              <h5 className="m-0 pb-2 fw-sbold themeBlue mt-4">
                View Booking Details
              </h5>
              <div className="table-responsive">
                <Table data={driverDataView?.bookingDetails} column={column} />
                <div className="d-flex justify-content-end">
                  {/* <CstmPagination /> */}
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default DriverDetail;
